<template>
  <div class="form" v-if="store.error !== null">
    <div class="item">
      <div class="form-detail-message" :class="store.error.style">
        <div
          class="form-detail-message-item message"
          v-if="store.error.type == 'Unauthorized'"
        >
          <div class="icon">
            <i class="fas fa-info"></i>
          </div>
          <div class="text">
            <p>Uzun süredir işlem yapmadığın için oturumun sonlanmıştır.</p>
          </div>
        </div>

        <div
          class="form-detail-message-item message"
          v-else-if="store.error.type == 'HataliOdeme'"
        >
          <div class="icon" v-if="store.error.message">
            <i class="fas fa-info"></i>
          </div>
          <div class="icon" style="border: none" v-else>😔</div>
          <div class="text">
            <p v-if="store.error.message" v-html="store.error.message"></p>
            <p v-else>
              Üzgünüz, beklenmedik bir hata oluştu. Lütfen daha sonra tekrar
              deneyiniz.
            </p>
          </div>
        </div>

        <div
          class="form-detail-message-item message"
          v-else-if="store.error.type == 'YasayanPoliceVarRakip'"
        >
          <div class="icon" style="border: none">😔</div>
          <div class="text">
            <p>
              Üzgünüz, poliçen yenileme vadesi içerisinde olmadığı için ne yazık
              ki fiyat çalışması yapamamaktayız.
            </p>
            <p>
              Poliçenin yenileme vadesi geldiğinde sana hatırlatma yapmamızı
              ister misin?
            </p>
            <p>
              <a
                @click="$app.yasayanPoliceSmsBildirimIstiyorum()"
                class="button inline-btn white-brd-btn"
                >Evet</a
              >
              <a
                @click="
                  $app.services.clearError();
                  $router.push({
                    name: 'KonutYenilemeHayır',
                  });
                "
                class="button inline-btn white-brd-btn"
                style="margin-left: 15px"
                >Hayır</a
              >
            </p>
          </div>
        </div>

        <div
          class="form-detail-message-item message"
          v-else-if="store.error.type == 'YasayanPoliceVarAxa'"
        >
          <div class="icon">
            <i class="fas fa-info"></i>
          </div>
          <div class="text">
            <p>
              Poliçene ilişkin tüm soruların için mevcut acentenle iletişime
              geçebilirsin. Mevcut poliçe ve acente bilgilerine ulaşmak için
              AXAFit uygulamamızı kullanabilirsin. AXAFit'i henüz indirmediysen
              aşağıdaki QR kodu telefonuna okutabilir, App Store ya da Google
              Play linklerinden indirebilirsin.
            </p>
            <div class="qr-code">
              <img src="@/assets/images/photo/qr.jpg" />
            </div>
            <ul class="app-menu">
              <li>
                <a target="_blank" href="https://app.adjust.com/n9getr1">
                  <img src="@/assets/images/icon/app-store.png" />
                </a>
              </li>
              <li>
                <a target="_blank" href="https://app.adjust.com/ry74wr6">
                  <img src="@/assets/images/icon/google-play.png" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div
          class="form-detail-message-item message"
          v-else-if="store.error.type == 'YenilemeOrYasayanVarmi'"
        >
          <div class="icon">
            <i class="fas fa-info"></i>
          </div>
          <div class="text">
            <p>
              Poliçene ilişkin tüm soruların için mevcut acentenle iletişime
              geçebilirsin. Mevcut poliçe ve acente bilgilerine ulaşmak için
              AXAFit uygulamamızı kullanabilirsin. AXAFit'i henüz indirmediysen
              aşağıdaki QR kodu telefonuna okutabilir, App Store ya da Google
              Play linklerinden indirebilirsin.
            </p>
            <div class="qr-code">
              <img src="@/assets/images/photo/qr.jpg" />
            </div>
            <ul class="app-menu">
              <li>
                <a target="_blank" href="https://app.adjust.com/n9getr1">
                  <img src="@/assets/images/icon/app-store.png" />
                </a>
              </li>
              <li>
                <a target="_blank" href="https://app.adjust.com/ry74wr6">
                  <img src="@/assets/images/icon/google-play.png" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div
          class="form-detail-message-item message"
          v-else-if="store.error.type == 'Otorizasyon'"
        >
          <div class="icon" style="border: none">😔</div>
          <div class="text">
            <p>
              Üzgünüz, girmiş olduğun bilgilerle fiyat çalışması yapamamaktayız.
            </p>
            <p>
              Fiyat çalışması talebin için dilersen sana en yakın acentemizle
              iletişime geçebilirsin. Acentelerimizin listesi için lütfen
              <a
                href="https://www.axasigorta.com.tr/en-yakin-acente"
                target="_blank"
                >tıkla.</a
              >
            </p>
          </div>
        </div>

        <div
          class="form-detail-message-item message"
          v-else-if="store.error.type == 'UnknownCreative'"
        >
          <div class="icon" v-if="store.error.message">
            <i class="fas fa-info"></i>
          </div>
          <div class="text">
            <p>
              Şirketimizde devam eden kasko poliçen olması sebebi ile fiyat
              çalışması yapamamaktayız. Poliçene ilişkin tüm soruların için
              mevcut acentenle iletişime geçebilirsin. Mevcut poliçe ve acente
              bilgilerine ulaşmak için AXAFit uygulamamızı kullanabilirsin.
            </p>
            <p>
              AXAFit'i henüz indirmediysen aşağıdaki QR kodu telefonuna
              okutabilir, App Store ya da Google Play linklerinden
              indirebilirsin.
            </p>
            <div class="form-detail-message-action">
              <div class="qr-code">
                <img src="@/assets/images/photo/qr.jpg" />
              </div>
              <ul class="app-menu">
                <li>
                  <a target="_blank" href="https://app.adjust.com/n9getr1">
                    <img src="@/assets/images/icon/app-store.png" />
                  </a>
                </li>
                <li>
                  <a target="_blank" href="https://app.adjust.com/ry74wr6">
                    <img src="@/assets/images/icon/google-play.png" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div
          class="form-detail-message-item message"
          v-else-if="store.error.type == 'AcenteClosed'"
        >
          <div class="icon" v-if="store.error.message">
            <i class="fas fa-info"></i>
          </div>
          <div class="text">
            <p v-html="store.error.message" v-if="store.error.message"></p>
            <p v-else>Üzgünüz, bu alandan fiyat çalışması yapamamaktayız.</p>
          </div>
        </div>

        <div
          class="form-detail-message-item message"
          v-else-if="store.error.type == 'MobilDogrulamaKodu'"
        >
          <div class="icon" v-if="store.error.message">
            <i class="fas fa-times"></i>
          </div>
          <div class="text">
            <p v-html="store.error.message" v-if="store.error.message"></p>
            <p v-else>
              Üzgünüz, beklenmedik bir hata oluştu. Lütfen daha sonra tekrar
              deneyiniz.
            </p>
          </div>
        </div>

        <div
          class="form-detail-message-item message"
          v-else-if="
            type == 'Unknown' ||
            type == 'Code24' ||
            type == 'Code27' ||
            type == 'HususiArac' ||
            type == 'LuksArac' ||
            type == 'RedirectError' ||
            type == 'Timeout'
          "
        >
          <div class="icon" v-if="store.error.message">
            <i class="fas fa-info"></i>
          </div>
          <div class="text">
            <p v-html="store.error.message" v-if="store.error.message"></p>
            <p v-else>
              Üzgünüz, beklenmedik bir hata oluştu. Lütfen daha sonra tekrar
              deneyiniz.
            </p>
          </div>
        </div>

        <div class="form-detail-message-item message" v-else>
          <div class="icon">
            <i class="fas fa-info"></i>
          </div>
          <div class="text">
            <p v-html="store.error.message" v-if="store.error.message"></p>
            <p v-else>
              Üzgünüz, beklenmedik bir hata oluştu. Lütfen daha sonra tekrar
              deneyiniz.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="item">
      <div class="submit">
        <ul>
          <li :style="store.error.type === 'Hata' ? 'max-width: unset;' : ''">
            <a
              @click="
                store.error = null
                // console.log('clear error')
              "
              class="button blue-brd-btn"
              >GERİ DÖN</a
            >
          </li>
          <li v-if="store.error.type !== 'Hata'">
            <div v-if="store.error.buttonRight">
              <a
                @click="store.error.buttonRight.onClick"
                class="button red-btn arrow-btn"
              >
                {{ store.error.buttonRight.text }}
              </a>
            </div>
            <div v-else>
              <a
                href="https://www.axasigorta.com.tr/"
                class="button red-btn arrow-btn"
              >
                ANA SAYFAYA GİT
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from "@/store";

export default {
  data() {
    return {
      store,
    };
  },
};
</script>
